import React, { useEffect, useState } from "react";
import { Breadcrumb, Card, CardBody, Dropdown, DropdownButton } from "react-bootstrap";
import { fetch } from "../../utils";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";

const AdminContact = () => {
  const [filter, setFilter] = useState("All");
  const [tableData, setTableData] = useState({
    columns: [],
    data: [],
    loading: false,
  });

  const filterContactList = (contactList) => {
    if (filter === "Today") {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return contactList.filter((contact) => {
        const date = new Date(contact.created_at);
        date.setHours(0, 0, 0, 0);
        return date.getTime() === today.getTime();
      });
    }

    if (filter === "Last 7 days") {
      const last7Days = new Date();
      last7Days.setHours(0, 0, 0, 0);
      last7Days.setDate(last7Days.getDate() - 6);

      return contactList.filter((contact) => {
        const date = new Date(contact.created_at);
        return date >= last7Days;
      });
    }

    return contactList;
  };

  const deleteContactData = async (contactId) => {
    if (!window.confirm("Are you sure you want to delete this contact record?")) {
      return;
    }

    try {
      const response = await fetch(
        `form/contact-reports/${contactId}`,
        "DELETE",
        null,
        null
      );

      const result = response?.data;

      if (!result?.success) {
        toast.error(result?.message || "Unable to delete record.");
        return;
      }

      setTableData((prev) => ({
        ...prev,
        data: prev.data.filter(
          (contact) => contact.form_contact_us_id !== contactId
        ),
      }));

      toast.success(result.message || "Record deleted successfully!");
    } catch (error) {
      console.error("Delete contact error:", error);
      toast.error("Error deleting contact data.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setTableData((prev) => ({
          ...prev,
          loading: true,
        }));

        const response = await fetch(
          "form/contact-reports",
          "GET",
          null,
          null
        );

        const result = response?.data;

        if (!result?.success) {
          toast.error(result?.message || "Unable to fetch contact reports.");
          setTableData((prev) => ({
            ...prev,
            data: [],
            loading: false,
          }));
          return;
        }

        const contactList = Array.isArray(result?.data?.contactList)
          ? result.data.contactList
          : [];

        const filteredContactList = filterContactList(contactList);

        const columns = [
          {
            name: "#",
            width: "60px",
            sortable: false,
            center: true,
            cell: (row, index) => index + 1,
          },
          {
            name: "Full Name",
            selector: (row) => row.full_name || "-",
            sortable: true,
            grow: 1,
          },
          {
            name: "Email",
            selector: (row) => row.email || "-",
            sortable: true,
            width: "20%",
          },
          {
            name: "Phone No",
            selector: (row) => row.phone_no || "-",
            sortable: true,
            width: "13%",
          },
          {
            name: "Message",
            selector: (row) => row.message || "-",
            sortable: true,
            grow: 2,
            wrap: true,
          },
          {
            name: "Date",
            selector: (row) => row.created_at || "",
            sortable: true,
            width: "15%",
            cell: (row) => {
              if (!row.created_at) return "-";

              const date = new Date(row.created_at);

              if (isNaN(date.getTime())) return "-";

              const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(
                date.getMonth() + 1
              ).padStart(2, "0")}/${date.getFullYear()}`;

              const formattedTime = `${String(date.getHours()).padStart(
                2,
                "0"
              )}:${String(date.getMinutes()).padStart(2, "0")}`;

              return `${formattedDate}, ${formattedTime}`;
            },
          },
      
        ];

        setTableData({
          columns,
          data: filteredContactList,
          loading: false,
        });
      } catch (error) {

        setTableData((prev) => ({
          ...prev,
          data: [],
          loading: false,
        }));

        toast.error("Error fetching contact reports.");
      }
    };

    fetchData();
  }, [filter]);

  return (
    <div className="container-fluid">
      <Breadcrumb className="p-2">
        <Breadcrumb.Item href="#">Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item active>Contact</Breadcrumb.Item>
      </Breadcrumb>

      <section className="content">
        <div className="container-fluid">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h4 className="mb-0">Contact Reports</h4>

              <DropdownButton
                id="contact-filter"
                title={`Filter: ${filter}`}
                variant="secondary"
              >
                <Dropdown.Item onClick={() => setFilter("All")}>
                  All
                </Dropdown.Item>

                <Dropdown.Item onClick={() => setFilter("Today")}>
                  Today
                </Dropdown.Item>

                <Dropdown.Item onClick={() => setFilter("Last 7 days")}>
                  Last 7 Days
                </Dropdown.Item>
              </DropdownButton>
            </Card.Header>

            <CardBody>
              <DataTableExtensions
                columns={tableData.columns}
                data={tableData.data}
                print={false}
                export={false}
              >
                <DataTable
                  columns={tableData.columns}
                  data={tableData.data}
                  progressPending={tableData.loading}
                  pagination
                  paginationPerPage={100}
                  paginationRowsPerPageOptions={[25, 50, 100]}
                  highlightOnHover
                  dense
                  responsive
                  noDataComponent="No contact records found."
                />
              </DataTableExtensions>
            </CardBody>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default AdminContact;